/**
 * Zustand Stores
 *
 * Centralized state management using Zustand.
 */

export {
  useMatterEstateAdminStore,
  useSelectedMatterId,
  useIsPanelOpen,
  useMatterPanelActions,
  type MatterTab
} from './matter-estate-admin-store';

export {
  useMatterListNavigationStore,
  getMatterListNavigationActions,
  isMatterListId
} from './matter-list-navigation-store';

export {
  useAccountNavigationStore,
  useAccountReturnPath,
  getAccountNavigationActions
} from './account-navigation-store';

export {
  useScrollPositionStore,
  getScrollPositionActions
} from './scroll-position-store';

export { useIntercomStore, getIntercomActions } from './intercom-store';

export {
  useRecordingSessionStore,
  useIsRecording,
  useIsPaused,
  useIsMinimised,
  useElapsedSeconds,
  useRecordingMatterId,
  useRecordingMatterName,
  useRecordingMatterReference,
  useActiveDeviceLabel,
  useStoredBytes,
  useIsMiniBarVisible,
  useRecordingSessionActions,
  getRecordingSessionActions,
  getRecordingSessionState,
  getElapsedMs,
  getElapsedSeconds,
  type PauseRange
} from './recording-session-store';

export {
  useRecordingUploadStore,
  useUploadRecordingId,
  useRecordingUploadActions,
  getRecordingUploadActions,
  getRecordingUploadState
} from './recording-upload-store';

/*
  There is no getting-started store any more (VALE-1830). It persisted an
  `initiated` array of clicked step keys to `localStorage` under a key that was
  NOT scoped to a user, so a new browser reported 0% and two people sharing one
  browser shared one checklist — and a step "completed" the moment its row was
  clicked, whether or not anything followed. Progress is per-user state about the
  account, so it lives on the account: see `lib/getting-started/` for the step
  definitions and the eligibility predicate, and
  `lib/hooks/use-getting-started-progress.ts` for the progress itself.

  Nothing else in the store survived the removal. `dismissedOnboardingSteps` had
  already been superseded by the backend's `doesNotSignLetters` preference
  (VALE-1633) and had no readers left.
*/
